import { SkeletonBlock } from '~/shared/ui'

export function ActionsBarLoadingSkeleton() {
  return (
    <div className="flex flex-wrap gap-x-2 gap-y-3 px-6 py-3">
      <div className="flex w-full items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <SkeletonBlock className="h-10 w-[240px]" />
          <SkeletonBlock className="h-8 w-[80px]" />
          <SkeletonBlock className="h-8 w-10" />
        </div>
        <div className="flex items-center gap-3">
          <SkeletonBlock className="h-8 w-[80px]" />
          <SkeletonBlock className="h-8 w-[100px]" />
        </div>
      </div>
    </div>
  )
}
